import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';

/**
 * Wraps admin routes to enforce permission checks.
 * Redirects to dashboard if user lacks the required permission.
 * @param {Object} props
 * @param {React.ReactNode} props.children - The route component to render
 * @param {[string, string]|null} props.permission - [module, action] e.g. ['members', 'view']. null = no check (e.g. Dashboard)
 */
const PermissionGuard = ({ children, permission }) => {
  const { admin, hasPermission } = useAdminAuth();
  const fallbackPath = admin?.role === 'affiliated_member' ? '/admin/target-members' : '/admin/dashboard';

  if (!permission) {
    return <>{children}</>;
  }

  const [module, action] = permission;
  if (!hasPermission(module, action)) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};

export default PermissionGuard;
